import * as utils from './utils/utils';
import * as globals from './utils/globals';

import './modules/Lazyload';
import Carousel from './modules/Carousel';

import KUTE from 'kute.js'

if (globals.isMobile) {
	utils.addClass(document.documentElement, 'is-mobile');
}
if (globals.ms_ie) {
	utils.addClass(document.documentElement, 'is-ie');
	// utils.addClass( document.documentElement, 'no-js');
}
if (globals.isTouch) {
	utils.removeClass(document.documentElement, 'no-touchevents');
	utils.addClass(document.documentElement, 'touchevents');
}

window.onload = event => {
	const $style = document.getElementById('main-css');

	if ($style.isLoaded) {
		init();
	} else {
		$style.addEventListener('load', event => {
			init();
		});
	}
};

function init() {
	setTimeout(() => {
		utils.addClass(document.documentElement, 'is-loaded');
		utils.addClass(document.documentElement, 'is-ready');
		utils.removeClass(document.documentElement, 'is-loading');
	}, 250);

	utils.set_vh();

	// Polyfill object fit images
	if (typeof objectFitImages !== 'undefined') {
		objectFitImages('.imageFit img, .imageFit video');
	}
  

	activeCarousel()
	function activeCarousel() {
		let carousel = document.querySelector(
			'.js-bloc-formations .carousel',
		);

		if (carousel) {
			let flkty = new Carousel(carousel);
		}
	}

	readMore();

	function readMore() {
		let buttonActif = document.querySelector(
			'.js-bloc-formations .js-formation.is-inview .read-more',
		);

		if (buttonActif) {
			let blocTxt = buttonActif.closest('article');
			let hauteur = blocTxt.offsetHeight;
			blocTxt.style.maxHeight = hauteur + 'px';

			buttonActif.addEventListener('click', e => {
				e.preventDefault();

				if (buttonActif.classList.contains('is-active')) {
					blocTxt.classList.remove('is-inview');
					/* blocTxt.style.maxHeight = 120 + "px"; */

					buttonActif.textContent = 'lire la suite';
					buttonActif.classList.remove('is-active');
				} else {
					blocTxt.classList.add('is-inview');
					buttonActif.classList.add('is-active');

					buttonActif.textContent = 'lire moins';
				}
			});
		}
	}

	accordion();

	function accordion() {
		var acc = document.querySelectorAll('.js-accordion');
		var i;

		for (i = 0; i < acc.length; i++) {
			acc[i].addEventListener('click', function () {
				this.classList.toggle('is-active');
				var panel = this.nextElementSibling;
				if (panel.style.maxHeight) {
					panel.style.maxHeight = null;
					this.closest('.accordion').style.borderTopColor = '#59393e';
				} else {
					this.closest('.accordion').style.borderTopColor = '#cc0e2e';
					panel.style.maxHeight = panel.scrollHeight + 'px';
				}
			});
		}
	}

	counter();

	function counter() {
		const counterElts = document.querySelectorAll('.js-accordion .counter') || false;

		if (counterElts) {
			for (let i = 0; i < counterElts.length; i++) {
				counterElts[i].textContent = i + 1 + '.';
			}
		}
	}

	chooseFile();

	function chooseFile() {
		const inputFile = document.querySelector('.page-contact [type=file]') || false;
		const zoneText = document.querySelector('.page-contact .js-file') || false;

		if (inputFile && zoneText) {
			inputFile.addEventListener('change', e => {
				zoneText.textContent = e.target.value.split('\\').pop() + ' est séléctionné';
			});
		}
	}

	addDatasetMenu();

	function addDatasetMenu() {
		if (
			document.querySelector('.menu #menu-item-167') ||
			document.querySelector('.menu #menu-item-168') ||
			document.querySelector('.menu #menu-item-169')
		) {
			document
				.querySelector('.menu #menu-item-167')
				.setAttribute('data-submenu-colonnes', '1');
			document
				.querySelector('.menu #menu-item-168')
				.setAttribute('data-submenu-colonnes', '1');
			document
				.querySelector('.menu #menu-item-169')
				.setAttribute('data-submenu-colonnes', '1');
		}
	}

	addActionMenu();

	function addActionMenu() {
		const hamburger = document.querySelector('nav .hamburger') || false;

		if (hamburger) {
			const header = document.querySelector('header.header-menu');
			const datasubmenu = document.querySelectorAll(
				'.header-menu [data-submenu-colonnes] > a',
			);
			const menuElt = document.querySelector(
				'.header-menu .menu');

			hamburger.addEventListener('click', e => {
				e.preventDefault();

				datasubmenu.forEach(elt => elt.parentElement.classList.remove('is-active'));

				menuElt.classList.remove('push-left');

				hamburger.classList.toggle('is-active');
				header.classList.toggle('is-active');

				if (document.documentElement.classList.contains('noScroll'))
					document.documentElement.classList.remove('noScroll');
				else document.documentElement.classList.add('noScroll');

				datasubmenu.forEach(elt => {
					elt.addEventListener('click', e => {
						e.stopPropagation();

						let linkbackASuppr =
							document.querySelectorAll('.header-menu .back-link') || false;
						let divTitreASuppr =
							document.querySelectorAll('.header-menu .title-submenu') || false;

						// Préviens l'éxecution multiple de addeventlistener et l'ajout multiple de eltText
						if (linkbackASuppr && divTitreASuppr) {
							linkbackASuppr.forEach(elt => elt.remove());
							divTitreASuppr.forEach(elt => elt.remove());
						}

						elt.parentElement.classList.add('is-active');
						menuElt.classList.add('push-left');

						let submenu = elt.parentElement.querySelector('.sub-menu');
						let eltText = e.target.textContent;

						let bloc =
							'<div class="back-link"><a href="/"><svg class="icon" width="30" height="30">' +
							'<use xlink:href="#chevron-bottom"></use>' +
							'</svg> retour</a></div>' +
							'<div class="title-submenu">' +
							eltText +
							'</div>';

						submenu.insertAdjacentHTML('afterbegin', bloc);

						window.setTimeout(() => {
							const backLink = document.querySelector(
								'[data-submenu-colonnes].is-active .back-link',
							);

							backLink.addEventListener('click', e => {
								e.preventDefault();
								e.stopPropagation();

								elt.parentElement.classList.remove('is-active');
								menuElt.classList.remove('push-left');
							});
						}, 100);
					});
				});
			});
		}
	}

	
/* 	animCircles();
  */
	function animCircles() {
    
		if(document.querySelector('.home')) {

			
		let tweenRouge = KUTE.fromTo(
				'#rouge2',
				{ path: '#rouge2' },
				{ path: '#rouge1' },
				{ repeat: 999, duration: 6000, yoyo: true },
			);
	
		let tweenGris = KUTE.fromTo(
				'#gris-path1',
				{ path: '#gris-path1' },
				{ path: '#gris-path2' },
				{ repeat: 999, duration: 6000, yoyo: true },
			);
	
		//tweenGris.start();
		tweenRouge.start();
		

		}
	}


	initialize()
	function initialize() {

		if(document.querySelector('.page-id-170')) {

			const latitude = document.querySelector('#map').dataset.latitude;
			const longitude = document.querySelector('#map').dataset.longitude;
			const zoom = document.querySelector('#map').dataset.zoom;

			var map = L.map('map').setView([latitude, longitude], zoom);

			L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
				attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
			}).addTo(map);
	
			
			L.marker([latitude, longitude]).addTo(map)
				.bindPopup('CTI')
				.openPopup();
	
		}
    }


	displayFichierUpload()

	function displayFichierUpload() {

		const file = document.querySelector('input[type="file"]');

		if(file) {

			file.addEventListener('change', function(e) {
				var nomfile = e.target.files[0].name;
				
				document.querySelector('#nomFichier').textContent = nomfile;
			});
		}
	}
}
